import React, { Component } from 'react';
import { autoLogin, loginBegin } from "../actions/LoginActions";
import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import "../common.css";

class LoginPage extends Component {

    state = {
        email: "",
        password: "",
    };

    constructor(props) {
        super(props);
        this.changeText = this.changeText.bind(this);
        this.signIn = this.signIn.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(autoLogin());
    }

    changeText(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    signIn() {
        const { dispatch } = this.props;
        const { email, password } = this.state;
    
        dispatch(loginBegin(email, password));
      }
    

    render() {

        const { loading } = this.props;

        return (
            <div className="form login_form">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <h1>Log In</h1>
                    </Grid>
                    <Grid item xs={12}>
                    <label className="label">Email</label>
                    </Grid>
                    <Grid item xs={12}>
                    <div>
                        <input
                        id="emailinput"
                        type="text"
                        name="email"
                        className="textbox logintext"
                        onChange={this.changeText}
                        />
                    </div>
                    </Grid>
                    <Grid item xs={12} />
                    <Grid item xs={12}>
                        <label id="passwordlabel">Password</label>
                    </Grid>
                    <Grid item xs={12}>
                        <div>
                            <input
                            id="passwordinput"
                            type="password"
                            name="password"
                            className="textbox logintext"
                            onChange={this.changeText}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div>
                            <button
                                id="loginbutton"
                                className="bbe-button"
                                disabled={loading}
                                onClick={this.signIn}
                                >
                            Login
                            </button>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    loading: state.loading.loading
});

export default connect(mapStateToProps)(LoginPage);